<template>
  <Dialog
    :visible="visible"
    modal
    pt:mask:class="bg-black/40 backdrop-blur-[1px]"
    pt:root:class="flex-1 max-w-[480px]"
  >
    <template #container>
      <div class="flex flex-col items-center space-y-5 rounded-md bg-[--v3-root-surface-ground] px-14 py-11">
        <div class="v3-body-regular-400-line-height-1.5 text-[--v3-global-textColor]">
          Switching to <strong class="notranslate font-medium" translate="no">{{ shopName }}</strong> shop...
        </div>
        <ProgressBar
          class="h-1.5 w-full"
          mode="indeterminate"
          pt:root:class="bg-[--v3-progress-bar-progressbarbg]"
          pt:value:class="bg-[--v3-progress-bar-progressbarvaluebg]"
        />
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from 'primevue/dialog';
import ProgressBar from 'primevue/progressbar';

defineProps<{
  shopName: string
  visible: boolean
}>();
</script>
